import { render, staticRenderFns } from "./FormPTE.vue?vue&type=template&id=5d56c0f8&scoped=true&lang=pug"
import script from "./FormPTE.vue?vue&type=script&lang=ts"
export * from "./FormPTE.vue?vue&type=script&lang=ts"
import style0 from "./FormPTE.vue?vue&type=style&index=0&id=5d56c0f8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d56c0f8",
  null
  
)

/* custom blocks */
import block0 from "./FormPTE.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FDocuments%2Fcomponents%2Fforms%2FPTE%2FFormPTE.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports